import { all } from 'redux-saga/effects';
import loginSaga from './login';
import logoutSaga from './logout';
import userSaga from './user';

export default function* securitySaga() {
  yield all([loginSaga(), logoutSaga(), userSaga()]);
}
